import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '@/components/SEO';

const NotFound = () => (
  <div className="min-h-screen pt-32 pb-20 px-6 text-center" data-testid="not-found-page">
    <SEO title="Page not found | Gangadhar Som" noindex />
    <h1 className="text-4xl font-serif font-light mb-4">Page not found</h1>
    <p className="text-muted-foreground mb-8">The page you are looking for does not exist or has moved.</p>
    <Link to="/gallery" className="underline">Browse the gallery</Link>
  </div>
);

export default NotFound;
